import { useState, useRef, useEffect } from 'react'

export const calculateTimeLeft = (targetDate: string | undefined) => {
  if (!targetDate) return ''
  const now = new Date().getTime()
  const target = new Date(targetDate).getTime()
  const difference = +target - +now

  if (difference < 0) return 'completed'

  const { days, hours, minutes, seconds } = getUnitsUntilTimeElapsed(targetDate)

  return `${days}:${hours}:${minutes}:${seconds}`
}

export const getUnitsUntilTimeElapsed = (targetDate: string | undefined) => {
  const now = new Date().getTime()
  const target = new Date(targetDate).getTime()
  const difference = +target - +now

  if (difference < 0)
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    }

  const convertTo2Digits = (interval: number) =>
    interval.toString().length === 1 ? `0${interval}` : interval

  const rawDays = Math.floor(difference / (1000 * 60 * 60 * 24))
  const rawHours = Math.floor((difference / (1000 * 60 * 60)) % 24)
  const rawMinutes = Math.floor((difference / 1000 / 60) % 60)
  const rawSeconds = Math.floor((difference / 1000) % 60)

  const days = convertTo2Digits(rawDays)
  const hours = convertTo2Digits(rawHours)
  const minutes = convertTo2Digits(rawMinutes)
  const seconds = convertTo2Digits(rawSeconds)

  return {
    days,
    hours,
    minutes,
    seconds,
  }
}

const useCountdownTimer = (targetDate: string | undefined) => {
  const [timeLeft, setTimeLeft] = useState<string>(
    calculateTimeLeft(targetDate),
  )
  const timerRef = useRef<number | null>(null)
  useEffect(() => {
    timerRef.current = window.setInterval(() => {
      const timeLeft = calculateTimeLeft(targetDate)
      setTimeLeft(timeLeft)
    }, 1000)

    return () => {
      if (timerRef.current) {
        window.clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [timerRef, targetDate])

  return timeLeft
}

export default useCountdownTimer
